// LeanData Calendaring Script Initialization
/* eslint-disable */
(function(windowRef, documentRef, fileLocation, functionName) {
  windowRef['LeanDataCalendaringObjName'] = functionName;

  windowRef[functionName] = function() {
    windowRef[functionName].variables = Array.from(arguments);
  };

  const scriptElement = documentRef.createElement('script');
  scriptElement.async = true;
  scriptElement.src = fileLocation;

  const target = document.getElementsByTagName('script')[0] || document.getElementsByTagName('head')[0];
  if (target) {
    target.parentNode.insertBefore(scriptElement, target);
  }
})(window, document, 'https://app.leandata.com/js-snippet/ld_calendaring.js', 'LDCalendaring');

// Initialize with parameters
LDCalendaring('00D36000001FMCQEA4', 'Demo Request Form Filled');

// Marketo Form Submission Handler Registration
(function() {
  const retryInterval = 1000; // Reduce polling frequency
  const maxRetries = 5;
  let retries = 0;

  function submitHandlerRegister(fName) {
    console.log('Registering Marketo form...');

    if (window[window.LeanDataCalendaringObjName] && window[window.LeanDataCalendaringObjName][fName] && window.MktoForms2) {
      window[window.LeanDataCalendaringObjName][fName]();
    } else if (retries < maxRetries) {
      retries++;
      setTimeout(function() {
        submitHandlerRegister(fName);
      }, retryInterval);
    } else {
      console.log('Max retries reached, Marketo form handler not found.');
    }
  }

  submitHandlerRegister('MktoFormReadyCallback');
})();

// Clearbit Form Event Handling
(function() {
  const handleClearbitEvent = function(evt) {
    if (evt && evt.detail && evt.detail.form && evt.detail.form.getId()) {
      evt.detail.form.submittable(false);
    }
  };

  document.addEventListener('clearbit-forms-marketo-enrichment-complete', handleClearbitEvent);
  document.addEventListener('clearbit-forms-marketo-enrichment-error', handleClearbitEvent);
})();
/* eslint-enable */
